export default {
	'select-item': 'Lütfen öğe seçin',

	'the-item': 'öğe?',

	'main-info': 'Ana Bilgi',
	'item-name': 'Öğe adı',
	'main-item': 'Ana Öğe',
	'item-no-automatic-or-manual': 'Öğe numarası (otomatik ya da manuel)',

	'item-type': 'Öğe türü',

	'item-classification': 'Öğe sınıflandırma',
	unit: 'Birim',

	'generate-barcode': 'Barkod Oluştur',

	'trading-info': 'Ticaret Bilgilendirmesi',
	'selling-price': 'Satış fiyatı',
	'tax-percent': 'Vergi yüzdesi',
	min: 'Minumum',
	max: 'Maksimum',
	manufacturer: 'Üretici',
	notes: 'Notlar',
	'favorite-item': 'Favori Ürün',
	unsaleable: 'Satılamaz',
	'the-cost-of-the-input-items': 'Girlmiş Ürüünün Maliyeti',
	// 'ingredients': 'ingredients'
	ingredients: 'İçerikler',
	'the-difference': 'Fark',
	'for-one-of-$-from-$': '{unit} için {item} lerden birini',
	'the-component-has-been-modified-successfully': 'Bileşen başarılı bir şekilde değiştirildi',
	'mixture-ingredient': 'Karışım içeriği',
	'purchasing-price': 'Satın alma fiyatı',
	'add-ingredient-after-save-item': 'Lütfen malzemeyi kaydettikten sonra bileşenleri ekleyin',
	'this-item-has-been-added-before-you-can-edit-the-item-instead': 'Bu Ürün daha önce eklenmişti. Ürünu düzenleyebilirsiniz.'
}